<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      isLogin: true
    }
  },
  mounted () {
    // console.log('app.vue mounted')
  },
  watch: {
    '$store.state.isLogin': function (val, oldVal) {
      console.log('store.state.isLogin: %s, old: %s', val, oldVal)
      this.isLogin = val
    }
  },
  methods: {
    change (p) {
      console.log('跳转到', p)
      this.$router.push({
        path: p
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
ul li {
  margin: 0;
}
li {
  list-style: none;
}
.m-item {
  color: #fff;
}
a:hover {
  color: #fff;
}
a:link{color: #fff;}
a:visited{color: #fff;}

.bigtitle {
  margin: 20px 0 0;
  font-size:18px;
  color:#fff;
  line-height:30px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/App.vue